import { render, staticRenderFns } from "./BranchOfficeNav.vue?vue&type=template&id=1bdcbbe5&scoped=true"
import script from "./BranchOfficeNav.vue?vue&type=script&lang=js"
export * from "./BranchOfficeNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdcbbe5",
  null
  
)

export default component.exports